import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async getPublishModelJob(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.post(`/autodesk/data-management/commands/${data.projectId}/get-publish/${data.itemId}`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },
    async publishModelJob(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.post(`/autodesk/data-management/commands/${data.projectId}/publish/${data.itemId}`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
